// Shopify Scratch Card Popup with Klaviyo Integration
// Logic, form handling, Klaviyo API call, and HTML5 Canvas scratch engine.

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const overlay = document.getElementById('ScratchPopupOverlay');
    if (!overlay) return;

    // Config options from data attributes
    const companyId = overlay.dataset.klaviyoCompanyId;
    const listId = overlay.dataset.klaviyoListId;
    const delay = parseInt(overlay.dataset.delay || '5') * 1000;
    const homepageOnly = overlay.dataset.homepageOnly === 'true';
    const showOnce = overlay.dataset.showOnce === 'true';
    const isDesignMode = overlay.dataset.designMode === 'true';

    const storageKey = 'scratch_popup_subscribed';
    const hasSubscribed = localStorage.getItem(storageKey);

    // If already subscribed, do not show (unless in theme editor)
    if (hasSubscribed && showOnce && !isDesignMode) {
      return;
    }

    // Check if homepage only
    if (homepageOnly && window.location.pathname !== '/' && window.location.pathname !== '/challenge' && !isDesignMode) {
      return;
    }

    // Elements
    const badge = document.getElementById('ScratchPopupBadge');
    const container = overlay.querySelector('.scratch-popup-container');
    const closeBtn = overlay.querySelector('#ScratchPopupClose');
    const form = overlay.querySelector('#ScratchPopupForm');
    const input = overlay.querySelector('#ScratchPopupEmail');
    const submitBtn = overlay.querySelector('#ScratchPopupSubmitBtn');
    const spinner = overlay.querySelector('#ScratchPopupSpinner');
    const errorMsg = overlay.querySelector('#ScratchPopupError');
    const successContainer = overlay.querySelector('#ScratchPopupSuccess');
    const scratchCardLock = document.getElementById('ScratchCardLock');
    const canvas = document.getElementById('ScratchCardCanvas');
    const discountCodeEl = document.getElementById('ScratchCardCode');

    // Scratch card state
    let isUnlocked = false;
    let scratchEngine = null;

    // Show badge initially if not subscribed
    if (badge && !hasSubscribed) {
      badge.classList.add('is-visible');
    }

    // Trigger Popup Timer
    if (isDesignMode) {
      // Keep open or open immediately in Shopify Customize Editor
      openPopup();
    } else {
      setTimeout(openPopup, delay);
    }

    // Popup visibility controls
    function openPopup() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Lock background scroll
      if (badge) {
        badge.classList.remove('is-visible');
      }
      initScratchCanvas();
    }

    function closePopup() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = ''; // Restore background scroll
      // If the user closed the popup without subscribing, show the teaser badge again
      if (badge && !localStorage.getItem(storageKey)) {
        badge.classList.add('is-visible');
      }
    }

    if (badge) {
      badge.addEventListener('click', function() {
        openPopup();
      });
    }

    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closePopup();
      }
    });

    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closePopup();
      }
    });

    // Email validation regex
    function validateEmail(email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(String(email).toLowerCase());
    }

    // Form Submission with Klaviyo Integration
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = input.value.trim();
      errorMsg.style.display = 'none';

      if (!email) {
        showError('Please enter your email address.');
        return;
      }

      if (!validateEmail(email)) {
        showError('Please enter a valid email address.');
        return;
      }

      // Check List ID & API Key settings
      if (!companyId || !listId) {
        showError('Klaviyo integration settings are not configured yet.');
        return;
      }

      // Set Loading state
      submitBtn.disabled = true;
      spinner.style.display = 'inline-block';

      // Klaviyo Client API Call
      const subscribeUrl = `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`;
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      fetch(subscribeUrl, {
        method: 'POST',
        headers: {
          'revision': '2024-05-15',
          'content-type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(async response => {
        let data = null;
        const text = await response.text();
        if (text) {
          try {
            data = JSON.parse(text);
          } catch(e) {
            console.warn('Response was not JSON:', text);
          }
        }
        if (response.ok) {
          handleSuccess();
        } else {
          // Parse Klaviyo errors if present
          let msg = 'Failed to subscribe. Please try again.';
          if (data && data.errors && data.errors.length > 0) {
            msg = data.errors[0].detail || msg;
          }
          showError(msg);
        }
      })
      .catch(err => {
        console.error('Klaviyo error:', err);
        showError('Subscription submitted, please verify your email connection or disable adblockers if errors persist.');
      })
      .finally(() => {
        submitBtn.disabled = false;
        spinner.style.display = 'none';
      });
    });

    function showError(text) {
      errorMsg.textContent = text;
      errorMsg.style.display = 'block';
    }

    function handleSuccess() {
      // Save subscription state in localstorage
      localStorage.setItem(storageKey, 'true');

      // Hide teaser badge permanently
      if (badge) {
        badge.classList.remove('is-visible');
        badge.style.display = 'none';
      }

      // Swap Form to Success message
      form.style.display = 'none';
      successContainer.style.display = 'flex';

      // Unlock scratch card
      unlockScratchCard();
    }

    function unlockScratchCard() {
      isUnlocked = true;
      if (scratchCardLock) {
        scratchCardLock.style.opacity = '0';
        setTimeout(() => {
          scratchCardLock.style.display = 'none';
        }, 400);
      }
    }

    // Click to copy discount code
    if (discountCodeEl) {
      discountCodeEl.addEventListener('click', function() {
        navigator.clipboard.writeText(discountCodeEl.textContent.trim())
          .then(() => {
            const originalSub = document.querySelector('.scratch-card-reveal-sub');
            if (originalSub) {
              originalSub.textContent = 'Code copied to clipboard! 🎉';
              originalSub.style.color = '#e1be35';
              setTimeout(() => {
                originalSub.textContent = 'Tap to copy code. Use at checkout.';
                originalSub.style.color = '#777';
              }, 2000);
            }
          })
          .catch(err => {
            console.error('Failed to copy text: ', err);
          });
      });
    }

    // HTML5 Canvas Scratch Engine Implementation
    function initScratchCanvas() {
      if (!canvas || scratchEngine) return;

      const ctx = canvas.getContext('2d');
      const rect = canvas.getBoundingClientRect();
      
      // Set actual canvas size (higher resolution matching client dimensions)
      const width = canvas.offsetWidth || 280;
      const height = canvas.offsetHeight || 280;
      canvas.width = width;
      canvas.height = height;

      // Configuration
      const overlayColor = canvas.dataset.overlayColor || '#8b8589';
      const overlayImageUrl = canvas.dataset.overlayImage;
      const brushRadius = 24;

      // Fill with solid cover color first
      ctx.fillStyle = overlayColor;
      ctx.fillRect(0, 0, width, height);

      // Add a metallic/noise overlay look
      ctx.fillStyle = 'rgba(255, 255, 255, 0.08)';
      for (let i = 0; i < width; i += 4) {
        for (let j = 0; j < height; j += 4) {
          if (Math.random() > 0.5) {
            ctx.fillRect(i, j, 2, 2);
          }
        }
      }

      // Add "Scratch Here" instruction text on canvas itself
      ctx.font = 'bold 18px var(--font-body--family, sans-serif)';
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH HERE', width / 2, height / 2);

      // Load overlay image if provided
      if (overlayImageUrl) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function() {
          ctx.drawImage(img, 0, 0, width, height);
          
          // Re-draw text on top of image
          ctx.font = 'bold 18px var(--font-body--family, sans-serif)';
          ctx.fillStyle = '#ffffff';
          ctx.fillText('SCRATCH HERE', width / 2, height / 2);
        };
        img.src = overlayImageUrl;
      }

      let isDrawing = false;
      let lastX = 0;
      let lastY = 0;
      let checkPercentageTimeout = null;
      let isCompleted = false;

      function getMousePos(e) {
        const canvasRect = canvas.getBoundingClientRect();
        // Handle touch vs mouse
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        
        // Account for scaling
        return {
          x: ((clientX - canvasRect.left) / canvasRect.width) * canvas.width,
          y: ((clientY - canvasRect.top) / canvasRect.height) * canvas.height
        };
      }

      function scratch(x, y) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, brushRadius, 0, Math.PI * 2);
        ctx.fill();
      }

      function scratchLine(startX, startY, endX, endY) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.lineWidth = brushRadius * 2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.stroke();
      }

      function getScratchedPercentage() {
        const imgData = ctx.getImageData(0, 0, width, height);
        const pixels = imgData.data;
        let transparentPixels = 0;
        
        // Check every 4th pixel alpha value to speed up calculation
        for (let i = 3; i < pixels.length; i += 16) {
          if (pixels[i] < 128) {
            transparentPixels++;
          }
        }
        
        const totalSampledPixels = pixels.length / 16;
        return (transparentPixels / totalSampledPixels) * 100;
      }

      function handleStart(e) {
        if (!isUnlocked || isCompleted) return;
        isDrawing = true;
        const pos = getMousePos(e);
        lastX = pos.x;
        lastY = pos.y;
        scratch(pos.x, pos.y);
      }

      function handleMove(e) {
        if (!isDrawing || !isUnlocked || isCompleted) return;
        e.preventDefault(); // Prevent scrolling on touch
        const pos = getMousePos(e);
        scratchLine(lastX, lastY, pos.x, pos.y);
        lastX = pos.x;
        lastY = pos.y;

        // Throttle percentage check
        if (!checkPercentageTimeout) {
          checkPercentageTimeout = setTimeout(() => {
            checkPercentageTimeout = null;
            const pct = getScratchedPercentage();
            if (pct >= 55) {
              completeScratch();
            }
          }, 200);
        }
      }

      function handleEnd() {
        isDrawing = false;
      }

      function completeScratch() {
        isCompleted = true;
        canvas.style.opacity = '0';
        setTimeout(() => {
          canvas.style.display = 'none';
        }, 400);
      }

      // Event listeners for canvas (Mouse)
      canvas.addEventListener('mousedown', handleStart);
      canvas.addEventListener('mousemove', handleMove);
      window.addEventListener('mouseup', handleEnd);

      // Event listeners for canvas (Touch)
      canvas.addEventListener('touchstart', handleStart, { passive: false });
      canvas.addEventListener('touchmove', handleMove, { passive: false });
      window.addEventListener('touchend', handleEnd);

      scratchEngine = {
        destroy: function() {
          canvas.removeEventListener('mousedown', handleStart);
          canvas.removeEventListener('mousemove', handleMove);
          window.removeEventListener('mouseup', handleEnd);
          canvas.removeEventListener('touchstart', handleStart);
          canvas.removeEventListener('touchmove', handleMove);
          window.removeEventListener('touchend', handleEnd);
        }
      };
    }
  });
})();
